import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { LogDetailsResponse } from '@/types/knowledge';

interface LogDetailSummaryProps {
  log: LogDetailsResponse;
  isLoading?: boolean;
}

export function LogDetailSummary({ log, isLoading = false }: LogDetailSummaryProps) {
  const metrics = [
    { label: 'Tickets', value: log.ticketsProcessed },
    { label: 'Documentos Criados', value: log.documentsCreated },
    { label: 'Erros', value: log.errorsCount },
    { label: 'Duracao (s)', value: (log.durationMs / 1000).toFixed(2) },
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <Card key={i}>
            <CardHeader className="pb-2">
              <Skeleton className="h-4 w-24" />
            </CardHeader>
            <CardContent>
              <Skeleton className="h-8 w-16" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((metric) => (
        <Card key={metric.label}>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {metric.label}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{metric.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
